import React from "react";
import Typography from "@mui/material/Typography";

const ParceiroParametroTopo = () => {
  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          Propriedades
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default ParceiroParametroTopo;
